export const PRIZE_HEADING_ID = 'prize_heading';
export const PRIZE_TEXT_ID = 'prize_text';
export const PRIZE_COUPON_ID = 'prize_coupon';
export const PRIZE_BUTTON_TEXT_ID = 'prize_button_text';
export const PRIZE_BUTTON_LINK_ID = 'prize_button_link';
export const LOGO_ID = 'logo_url';
export const WEBPAGE_ID = 'webpage';
export const EMAIL_ID = 'email';
